import { render, staticRenderFns } from "./CommunicationForm.vue?vue&type=template&id=1a12ba5e&scoped=true"
import script from "./CommunicationForm.vue?vue&type=script&lang=js"
export * from "./CommunicationForm.vue?vue&type=script&lang=js"
import style0 from "./CommunicationForm.vue?vue&type=style&index=0&id=1a12ba5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12ba5e",
  null
  
)

export default component.exports